import styled from 'styled-components'
import { characters } from '../../data/characters'
import { useCharacterInteraction } from '../../hooks/useCharacterInteraction'
import CharacterPanel from './CharacterPanel'

const HeroContainer = styled.section`
    height: 100vh;
    display: flex;
    position: relative;
    z-index: 2;
    transform: translateZ(0);
    backface-visibility: hidden;
    will-change: contents;

    @media (max-width: 768px) {
        flex-direction: column;
        height: auto;
    }
`

const HeroSection = () => {
    const {
        activeCharacter,
        handleCharacterInteraction,
        isMobile,
        // 向后兼容的命名
        hoveredCharacter,
        setHoveredCharacter
    } = useCharacterInteraction()

    // 为了确保完全向后兼容，保留原有的事件处理函数
    const handleCharacterHover = (characterId) => {
        handleCharacterInteraction(characterId, 'enter')
    }

    const handleCharacterLeave = () => {
        handleCharacterInteraction(null, 'leave')
    }

    return (
        <HeroContainer className={`hero-section ${isMobile ? 'mobile' : 'desktop'}`}>
            {characters.map((character) => (
                <CharacterPanel
                    key={character.id}
                    character={character}
                    // 新props（移动端用）
                    isActive={activeCharacter === character.id}
                    onInteraction={handleCharacterInteraction}
                    isMobile={isMobile}
                    // 保留旧props（桌面端兼容）
                    isHovered={hoveredCharacter === character.id}
                    onHover={() => handleCharacterHover(character.id)}
                    onLeave={handleCharacterLeave}
                />
            ))}
        </HeroContainer>
    )
}

export default HeroSection